module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.type))])]), _vm._v(" "), _vm._l((_vm.types), function(typeobj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.journalTo(typeobj)
      },
      nativeOn: {
        "click": function($event) {
          _vm.nowType = typeobj
        }
      }
    }, [_vm._v(_vm._s(_vm.showName(typeobj)))])], 1)])
  })], 2)])]) : _c('router-view', {
    attrs: {
      "type": _vm.nowType
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b9ef612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Journal.vue
// module id = 1184
// module chunks = 4